import { render, staticRenderFns } from "./IdeaBoard.vue?vue&type=template&id=37784eb2&scoped=true"
import script from "./IdeaBoard.vue?vue&type=script&lang=ts"
export * from "./IdeaBoard.vue?vue&type=script&lang=ts"
import style0 from "./IdeaBoard.vue?vue&type=style&index=0&id=37784eb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37784eb2",
  null
  
)

export default component.exports